import { GridRequest } from "projects/app-core/src/models/gridRequest";

export interface ForumsListGridRequest extends GridRequest<ForumListSort, ForumListFilter, ForumSearch, ForumListDateFilter> {
    tab?: ForumsListTab
    currency?: string;
}

export enum ForumsListTab {
    UP_COMING_ADMIN = "UP_COMING_ADMIN",
    ONGOING_ADMIN = "ONGOING_ADMIN",
}

export enum ForumListSort {
    FORUM_START_DATE = "FORUM_START_DATE",
    PRICE = "PRICE",
}

export enum ForumListFilter {
    CATEGORY = "CATEGORY",
    PRESENTER_ID = "PRESENTER_ID",
    ACTIVE = "ACTIVE",
    USER_PERSONALISED = "USER_PERSONALISED",
    PAYMENT_TYPE = "PAYMENT_TYPE",
    TEST_FORUMS = "TEST_FORUMS",
}

export enum ForumSearch {
    EVENT_NAME = "EVENT_NAME",
}

export enum ForumListDateFilter {
    FORUM_START_DATE = "FORUM_START_DATE",
    CREATED_DATE = "CREATED_DATE",
    REGISTRATION_CUT_OFF = "REGISTRATION_CUT_OFF",
    VISIBLE_FROM = "VISIBLE_FROM",
}